import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Button } from "reactstrap";

const BarChart = ({ topten }) => {
  const [series, setSeries] = useState([]);
  const [seriesy, setSeriesy] = useState([]);
  const [options, setOptions] = useState({});

  useEffect(() => {
    if (topten) {
      const pendingData = Object.values(topten.top_crops).map(
        (crop) => crop.pending
      );
      const rejectedData = Object.values(topten.top_crops).map(
        (crop) => crop.rejected
      );
      const approvedData = Object.values(topten.top_crops).map(
        (crop) => crop.approved
      );
      const pendingAmount = Object.values(topten.top_crops).map(
        (crop) => crop.pending_amount
      );
      const rejectedAmount = Object.values(topten.top_crops).map(
        (crop) => crop.rejected_amount
      );
      const approved_amount = Object.values(topten.top_crops).map(
        (crop) => crop.approved_amount
      );
      console.log("Rejected account", rejectedAmount);
      console.log(pendingAmount);

      const names = Object.keys(topten.top_crops);

      setSeries([
        {
          name: "Approved",
          data: approvedData,
        },
        {
          name: "Pending",
          data: pendingData,
        },
        {
          name: "Rejected",
          data: rejectedData,
        },
      ]);

      setOptions({
        legend: {
          itemMargin: {
            horizontal: 30,
            vertical: 0,
          },
        },
        chart: {
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 5,
            columnWidth: "75%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 6,
          colors: ["transparent"],
        },

        colors: ["#18a07a", "#f1ad02", "#d84848"],
        xaxis: {
          categories: names,
        },
        grid: {
          borderColor: "#f1f1f1",
        },
        fill: {
          opacity: 20,
        },
        title: {
          text: "Top 10 Crops",
          align: "left",
          style: {
            fontSize: "22px",
          },
        },
        tooltip: {
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                const pendingAmountData = pendingAmount[dataPointIndex].toLocaleString();
                const rejectedAmountData = rejectedAmount[dataPointIndex].toLocaleString();
                const approvedAmountData = approved_amount[dataPointIndex].toLocaleString();
          
              let backgroundColor;
              let loanType;
          
              if (seriesIndex === 0) { 
                backgroundColor = "#18a07a";
                loanType = "Approved Loans";
              } else if (seriesIndex === 1) { 
                backgroundColor = "#f1ad02";
                loanType = "Pending Loans";
              } else if (seriesIndex === 2) { 
                backgroundColor = "#d84848";
                loanType = "Rejected Loans";
              }
          
              let tooltipContent = '<div style="background-color: ' + backgroundColor + '; padding:  10px; color: white; border: 1px solid ' + backgroundColor + '; height: 60px; display: flex; flex-direction: column; justify-content: center; align-items:center;">';
          
              tooltipContent +=
              "<div>" + loanType + ": </div>" + 
              "<div>"+ "PKR" + " " + (loanType === 'Approved Loans' ? approvedAmountData : (loanType === 'Pending Loans' ? pendingAmountData : rejectedAmountData)) + "</div>";
              
          
              tooltipContent += "</div>";
              return tooltipContent;
            },

          },
          
          
          
          
      });
    }
  }, [topten]);

  return (
    <React.Fragment>
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={350}
        style={{ border: "0.5px solid #bfc7d9", borderRadius: "10px" }}
      >
        <h4>Top 10 Crops</h4>
      </ReactApexChart>
    </React.Fragment>
  );
};

export default BarChart;
